
import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

 const actionEnums = [
     BaseActionEnum.CreateNew,
     BaseActionEnum.Refresh
];

export const actionItems = getActionMenuItems(actionEnums);        
